export enum ADMIN_ROLES {
  ICT = 100,
  ADMIN = 101,
  TREASURY = 102,
  ALTERNATIVE_CHANNEL = 103,
  BDM = 104,
  OTHER_SYSTEM = 500,
  SALES = 501
};
